export default {
  pageTitle: 'ホーム',
  metaDescription: 'PT TEFは、特殊材料を用いた圧力容器・熱交換器・産業機器のインドネシアの製作会社です。石油・ガス、石油化学、発電業界向けに製品を提供しています。',
  videoNotSupported: 'お使いのブラウザはvideoタグに対応していません。',
  counters: {
    project: 'プロジェクト',
    countriesExport: '輸出国数',
    typeOfMaterials: '取扱材料の種類',
    customers: '顧客数',
  },
  oneStopSolutions: {
    title: 'ワンストップソリューション',
    description:
      'TEFはステンレス鋼、ニッケル基合金、チタン、その他の特殊材料を用いた製品製作において豊富な経験を有しています。私たちの専門知識が耐久性、精度、そして国際基準への準拠を保証します。',
    fabrication: {
      title: '製作ソリューション',
      description: '当社では、以下をはじめとする多様な産業機器の製作を行っています……',
      readMore: '続きを読む',
    },
    reconditioning: {
      title: '修繕・技術サービス',
      description: '新規製作に加え、メンテナンスおよび修繕サービスも提供しています…',
      readMore: '続きを読む',
    },
  },
  pioneers: {
    title: '私たちは特殊材料による<br>製作の先駆者です',
    description:
      'エンジニアリングの卓越性、コンサルティングの専門知識、高度な溶接技術、そして特殊材料の取り扱いへの強いコミットメントにより、TEFは業界の絶え間なく進化する要求に応えるため、革新を続けています。',
  },
  gallery: {
    title: '私たちの仕事のギャラリー',
    tabs: {
      machine: '機械',
      area: 'エリア',
      worker: '作業員',
    },
  },
  news: {
    title: '最新ニュース・ブログ',
    subtitle: 'PT TEFからの最新情報とインサイトをご覧ください',
    readMore: '続きを読む',
    moreButton: 'ニュース・その他のブログ',
  },
  clients: {
    title:
      '私たちはお客様、従業員、地域社会からの信頼に支えられ、<br>お客様に満足いただける高品質な製品をお届けすることに誇りを持っています。',
  },
  moto: {
    title: 'START',
    subtitle: 'TOKKIグループの標語として',
    skillUp: { word: 'Skill-up', desc: '私たちは個々の技術レベルの向上に一層努めます。' },
    timely: { word: 'Timely', desc: '必要な書類、資材、製品を適時に提供できるよう努めます。' },
    active: { word: 'Active', desc: '指示を待つことから脱却し、仕事に対して積極的な姿勢を取ります。' },
    responsibility: { word: 'Responsibility', desc: '私たちは自らの仕事に責任を持ちます。' },
    try: { word: 'Try', desc: '私たちは現状に満足せず、新しいことに挑戦します。<br>言い訳を探すのではなく、まず行動します。' },
  },
};
